import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { UserInterfaceService } from '../../services/user-interface.service';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { ToolbarButtonEnum } from '../../enums/toolbar-button.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { UserAuthModel } from '../../models/user-auth.model';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit, OnDestroy {

  sidenavLeftOpened: Boolean = false;
  sidenavLeftSubscription: Subscription;

  sidenavRightOpened: Boolean = false;
  sidenavRightSubscription: Subscription;

  title: string = '';
  titleSubscription: Subscription;

  toolbarButton: ToolbarButtonEnum = ToolbarButtonEnum.None;
  toolbarButtonSubscription: Subscription;

  authentication: boolean = false;
  authSubscription: Subscription;

  selected:string;
  isMobile:boolean = false;

  user: UserAuthModel;


  constructor(
    private userInterfaceService: UserInterfaceService,
    private location: Location,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private route: ActivatedRoute,
 ) { 

      breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
        this.isMobile = result.matches;     
      });

  }

  ngOnInit() {
    this.sidenavLeftSubscription = this.userInterfaceService.getSidenavLeft().subscribe(result =>{
      this.sidenavLeftOpened = result;
    });

    this.sidenavRightSubscription = this.userInterfaceService.getSidenavRight().subscribe(result =>{
      this.sidenavRightOpened = result;
    });

    this.titleSubscription = this.userInterfaceService.getTitle().subscribe(result =>{
      this.title = result;
    });

    this.toolbarButtonSubscription = this.userInterfaceService.getToolbarButton().subscribe(result => {
      this.toolbarButton = result;
    });

    this.authSubscription = this.userInterfaceService.getAuthentication().subscribe(result=>{
      this.authentication = result;
    });

    this.authMethod();

  }

  ngOnDestroy(): void {
    this.sidenavLeftSubscription.unsubscribe();
    this.sidenavRightSubscription.unsubscribe();
    this.authSubscription.unsubscribe();
  }

  menuToggle()
  {
    var data = !this.sidenavLeftOpened;
    this.userInterfaceService.setSidenavLeft(data);
  }

  sidenavToggle()
  {
    var data = !this.sidenavRightOpened;
    this.userInterfaceService.setSidenavRight(data);
  }

  back() {
    this.location.back();
  }

  home() {
    this.router.navigate(['home/dashboard']);
    this.selected="";
  }

  goToAnagrafica(){     
    this.selected="anagrafica";
    this.router.navigate(['reports/report/anagrafica']);

 }

 goToUsers(){     
  this.selected="users";
  this.router.navigate(['reports/report/users']);

}

 goToPesate(){     
   this.selected="pesate";
  this.router.navigate(['reports/report/pesate']);
}

goToMacros(){    
  this.selected="macros";
  this.router.navigate(['reports/report/macro']);
}

goToReport(){
  this.selected="report";     
  this.router.navigate(['reports/report/report-list']);
}

goToModulistica(){    
  this.selected="modulistica"; 
  this.router.navigate(['reports/report/modulistica']);
}

goToBmr(){
  this.selected="bmr";
  this.router.navigate(['reports/report/utility/bmr']);
}

goToBf(){
  this.selected="bf";
  this.router.navigate(['reports/report/utility/bodyfat']);
}

goToBmi(){
  this.selected="bmi";
  this.router.navigate(['reports/report/utility/bmi']);
}

goToMacroProgressioni(){
  this.selected="progressioni";
  this.router.navigate(['reports/report/utility/macro-progressioni']);
}

logoutUser()
{
  sessionStorage.removeItem('ubm-login');
  this.authService.setAuthentication(null);
  this.authentication = false;
  this.home();
}

authMethod(){
  // var user = this.authService.getAuthentication();
  // this.route.data.subscribe(routeData => {
  //   let data = routeData['data'];
  //   if (data) {
  //     this.user = data;
  //   }
  // });

  this.authSubscription = this.authService.getAuthentication().subscribe(result => {
    this.user = result;

    if (!this.authentication) {
      var auth = sessionStorage.getItem('ubm-login');
      if (auth) {
        this.authentication = true;
        this.authService.setAuthentication(JSON.parse(auth));        
      }else {
        this.authentication = false;
        this.router.navigate(['home/dashboard']);
      }
    }
  });


}



}
